import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceMetrics = ({ botData }) => {
  const metrics = [
    {
      label: 'Current ROI',
      value: botData?.roi,
      change: '+12.5%',
      changeType: 'positive',
      icon: 'TrendingUp',
      description: 'Return on Investment over the selected period'
    },
    {
      label: 'Total Trades',
      value: botData?.totalTrades,
      change: '+45',
      changeType: 'positive',
      icon: 'Activity',
      description: 'Total number of executed trades'
    },
    {
      label: 'Win Rate',
      value: botData?.winRate,
      change: '+2.1%',
      changeType: 'positive',
      icon: 'Target',
      description: 'Percentage of profitable trades'
    },
    {
      label: 'Max Drawdown',
      value: botData?.maxDrawdown,
      change: '-1.2%',
      changeType: 'negative',
      icon: 'TrendingDown',
      description: 'Maximum peak-to-trough decline'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {metrics?.map((metric, index) => (
        <div key={index} className="bg-card border border-border rounded-2xl p-6 trading-shadow">
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${
              metric?.changeType === 'positive' ? 'bg-success/10' : 'bg-error/10'
            }`}>
              <Icon 
                name={metric?.icon} 
                size={24} 
                className={metric?.changeType === 'positive' ? 'text-success' : 'text-error'} 
              />
            </div>
            <div className="group relative">
              <Icon name="Info" size={16} className="text-muted-foreground cursor-help" />
              <div className="absolute right-0 top-6 w-64 p-3 bg-popover border border-border rounded-lg text-sm opacity-0 group-hover:opacity-100 pointer-events-none trading-transition z-50">
                {metric?.description}
              </div>
            </div>
          </div>
          
          <div className="space-y-2">
            <h3 className="text-sm font-medium text-muted-foreground">{metric?.label}</h3>
            <div className="flex items-end justify-between">
              <span className="text-2xl font-bold text-foreground">{metric?.value}</span>
              <div className={`flex items-center space-x-1 text-sm font-medium ${
                metric?.changeType === 'positive' ? 'text-success' : 'text-error'
              }`}>
                <Icon 
                  name={metric?.changeType === 'positive' ? 'ArrowUp' : 'ArrowDown'} 
                  size={14} 
                />
                <span>{metric?.change}</span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PerformanceMetrics;